import { render, staticRenderFns } from "./OrderSingleHeader.vue?vue&type=template&id=2f26318a&"
import script from "./OrderSingleHeader.vue?vue&type=script&lang=js&"
export * from "./OrderSingleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports